import { rewardfulBootstrap } from 'server/lib/inline-scripts'

let initialized = false

export const initialize = async cookiePreference => {
  if (typeof window === 'undefined' || !cookiePreference || initialized) {
    return
  }

  const gpcValue = window.navigator.globalPrivacyControl

  if (gpcValue) return

  if (cookiePreference === 'accepted' || cookiePreference.split(',').includes('targeting')) {
    initialized = true
    const script = document.createElement('script')
    script.innerHTML = rewardfulBootstrap
    document.head.appendChild(script)
    const script2 = document.createElement('script')
    script2.async = true
    script2.dataset.rewardful = 'd89eb8'
    script2.src = 'https://r.wdfl.co/rw.js'
    document.head.appendChild(script2)
  }
}
